import { track as vercelTrack } from "@vercel/analytics";

export const track = (eventName, properties = {}) => {
  const userEmail = localStorage.getItem("userEmail") || undefined;
  vercelTrack(eventName, {
    ...properties,
    ...(userEmail && { userEmail }),
  });
};
